export type CalculateTourEss = {
  general: CalculateTourGeneralEss;
};

export type CalculateTourGeneralEss = {
  scoreLetter: string;
  score: number;
  maxScore: number;
  topics: {
    PARITY_EQUALITY: {
      score: number;
      maxScore: number;
      sections: {
        ARTISTIC_TEAM: { score: number; maxScore: number };
        OCCASIONAL_OPERATIONAL_TEAM: { score: number; maxScore: number };
        PERMANENT_PRODUCTION_TEAM: { score: number; maxScore: number };
        TRANSPARENCY_MANAGEMENT: { score: number; maxScore: number };
      };
    };
    LOCAL_IMPACT_RSE_ENGAGEMENT: {
      score: number;
      maxScore: number;
      sections: {
        ECONOMIC_SOCIAL_IMPACT: { score: number; maxScore: number };
      };
    };
    ACCESSIBILITY_SOCIAL_DIALOGUE: {
      score: number;
      maxScore: number;
      sections: {
        ACCESSIBILITY: { score: number; maxScore: number };
        RISK_PREVENTION: { score: number; maxScore: number };
        TEAM_MANAGEMENT: { score: number; maxScore: number };
      };
    };
  };
};

export const EMPTY_CALCULATE_TOUR_ESS: CalculateTourEss = {
  general: {
    scoreLetter: '-',
    score: 0,
    maxScore: 0,
    topics: {
      PARITY_EQUALITY: {
        score: 0,
        maxScore: 0,
        sections: {
          ARTISTIC_TEAM: { score: 0, maxScore: 0 },
          OCCASIONAL_OPERATIONAL_TEAM: { score: 0, maxScore: 0 },
          PERMANENT_PRODUCTION_TEAM: { score: 0, maxScore: 0 },
          TRANSPARENCY_MANAGEMENT: { score: 0, maxScore: 0 },
        },
      },
      LOCAL_IMPACT_RSE_ENGAGEMENT: {
        score: 0,
        maxScore: 0,
        sections: {
          ECONOMIC_SOCIAL_IMPACT: { score: 0, maxScore: 0 },
        },
      },
      ACCESSIBILITY_SOCIAL_DIALOGUE: {
        score: 0,
        maxScore: 0,
        sections: {
          ACCESSIBILITY: { score: 0, maxScore: 0 },
          RISK_PREVENTION: { score: 0, maxScore: 0 },
          TEAM_MANAGEMENT: { score: 0, maxScore: 0 },
        },
      },
    },
  },
};
